<template>
  <!--Select Suggestion -->
  <div class="vx-row">
    <vx-card v-if="!options.length" class="bg-danger-gradient text-white opacity-75">
      <h3 class="text-white">
        {{ $t('messages.no_suggestion_service') }}
      </h3>
    </vx-card>
    <div class="vx-col p-3 w-full" :key="index" v-for="(service, index) in options">
      <vx-card
        card-border
        no-shadow
        :class="
          selectedService.find(s => s === service.value) ? 'bg-success-gradient text-white opacity-75' : ''
        "
      >
        <div slot="footer">
          <vs-row class="flex items-center" :class="{ 'pt-5': !service.value.employeeUserAvatar }">
            <avatar
              v-if="service.value.employeeUserAvatar"
              :id="service.value.employeeUserAvatar"
              size="50px"
            />
            <h1>{{ service.label }}</h1>
          </vs-row>
          <vs-row vs-justify="flex-end">
            <vs-button
              v-if="!selectedService.find(s => s === service.value)"
              icon-pack="feather"
              icon="icon-check"
              type="border"
              color="success"
              @click="selectService(service.value)"
            >
              {{ $t('button.select') }}
            </vs-button>
            <template v-else>
              <div class="m-2 p-4 text-lg bg-primary rounded-full">
                اولویت {{ selectedService.findIndex(s => s === service.value) + 1 }}
              </div>
              <vs-button
                icon-pack="feather"
                icon="icon-"
                color="danger"
                @click="selectService(service.value)"
              >
                {{ $t('button.deselect') }}
              </vs-button>
            </template>
          </vs-row>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Avatar from '@/views/components/common/Avatar'
export default {
  name: 'SelectSuggestion',
  components: { Avatar },
  props: {
    subject: String,
    locale: String,
    date: String,
    category: String,
    specialty: String,
    address: Object
  },
  data: () => ({
    suggestions: { preferredPlaces: [], preferredServices: [] },
    selectedService: [],
    loaded: false
  }),
  watch: {
    selectedService(val) {
      this.$emit('input', { preferredPlaces: this.selectedPlaces, preferredServices: val })
    }
  },
  computed: {
    options() {
      if (this.suggestions.preferredServices)
        return this.suggestions.preferredServices.map(s => ({
          value: s,
          label: `${s.placeAlias} - ${s.employeeUser}`
        }))
      return []
    },
    selectedPlaces() {
      const places = []
      this.selectedService.forEach(s => {
        if (places.indexOf(p => p.placeId === s.placeId) === -1) {
          places.push(this.suggestions.preferredPlaces.find(p => p.placeId === s.placeId))
        }
      })
      return places
    }
  },
  methods: {
    selectService(service) {
      const findIndex = this.selectedService.findIndex(s => s === service)
      if (findIndex > -1) {
        this.selectedService.splice(findIndex, 1)
      } else {
        this.selectedService.push(service)
      }
    }
  },
  mounted() {
    if (this.address)
      this.$store
        .dispatch('request/fetchSuggestionBySubject', {
          category: this.category,
          subject: this.subject,
          data: {
            owner: this.$store.state.AppActiveUser.id,
            location: this.address.location,
            geoInfo: this.address,
            locale: this.locale == 'fa' ? undefined : this.locale,
            date: this.date,
            specialty: this.specialty
          }
        })
        .then(res => {
          this.suggestions = res.data
          this.loaded = true
        })
  }
}
</script>

<style scoped></style>
